export default __webpack_public_path__ + "static/media/33.30f142ab.jpg";